import { sButton } from "./StyledButton";
import { sDiv } from "./StyledDiv";
import { sHeader } from "./StyledHeader";
import { sInput } from "./StyledInput";
import { sImage } from "./StyledImage";
import { sSubHeader } from "./StyledSubHeader";
import { sText } from "./StyledText";
import { scrollDiv } from "./ScrollDiv";

import { sForm } from "./StyledForm";
import GenericStyleGuide from "./ReadStyleGuide";
import { sSpan } from "./StyledSpan";
import { sTableData } from "./StyledTableData";

export const StyledSpan = sSpan;
export const StyledInput = sInput;
export const StyledForm = sForm;
export const StyledButton = sButton;
export const StyledDiv = sDiv;
export const StyledHeader = sHeader;
export const StyledImage = sImage;
export const StyledSubHeader = sSubHeader;
export const StyledText = sText;
export const StyledScrollDiv = scrollDiv;
export const StyledTableData = sTableData;

export const ReadStyleGuide = GenericStyleGuide;
